import { PluginKey } from '@progress/kendo-editor-common';
/**
 * @hidden
 */
export var editorPropsKey = new PluginKey('editor-props');